import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const UPLOAD_ID_ERROR_COMPONENT_PROPS = {
  image: 'illustration_emptystates_no-items',
  dataTestId: 'upload-id-error-component',
  variant: VARIANTS.EmptyStatusVariantType.DEFAULT,
};

export { UPLOAD_ID_ERROR_COMPONENT_PROPS };
